module.exports = __webpack_public_path__ + "img/householdManagement.d4d4b63a.svg";